import React, { useEffect, useMemo, useState } from 'react';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import TopSelectBar from './TopSelectBar';
import useResponsive from '../../../../Hooks/useResponsive';
import TeamPerfomanceOverview from './TeamPerfomanceOverview';
import { Box, Button } from '@mui/material';
import DailyTeamRevenue from './DailyTeamRevenue';
import DailyAssessmentCount from './DailyAssessmentCount';
import TeamWiseAnalysis from './TeamWiseAnalysis';
import ProjectWise from './ProjectWise';
import OGDOverview from './OGDOverview';
import TeamUserPerfomance from './TeamUserPerfomance';
import ChaserCrewPerfomance from './ChaserCrewPerfomance';
import {
  clearChaserCrewPerfomance,
  clearDailyAssessmentCount,
  clearDailyTeamRevenue,
  clearOgdOverview,
  clearProjectWise,
  clearTeamPerfomanceOverview,
  clearTeamUserPerfomance,
  clearTeamWiseAnalysis,
} from '../../../../redux/features/poinTrackerSlice';
import { useDispatch } from 'react-redux';
import DatePickerCustom from '../../../../components/DatePicker/DatePickerCustom';
import dayjs from 'dayjs';
import { AnimatePresence, motion } from 'framer-motion';
import { animations } from '../../../../utils/animationVariants';
import { Icon } from '@iconify/react/dist/iconify.js';
import MonthlyWiseGlobalFilter from './MonthlyWiseGlobalFilter';
import DetailedPerfomanceMetrics from './DetailedPerfomanceMetrics';

const TeamWiseAnalyticsLanding = () => {
  //LOCAL STORAGE GET ITEMS
  const storedData = localStorage.getItem('TeamWiseAnalyticsLanding');
  const parsedStoredData = storedData ? JSON.parse(storedData) : {};
  const [selectedModuleType, setSelectedModuleType] = useState(parsedStoredData?.selectedModuleType || 1);
  const [teamPerfomanceParentDate, setTeamPerfomanceParentDate] = useState(
    parsedStoredData?.teamPerfomanceParentDate || dayjs().format('YYYY-MM-DD'),
  );
  const [teamWiseAnalysisDate, setTeamWiseAnalysisDate] = useState(
    parsedStoredData?.teamWiseAnalysisDate || dayjs().format('YYYY-MM-DD'),
  );
  const [projectWiseFromDate, setProjectWiseFromDate] = useState(
    parsedStoredData?.projectWiseFromDate || dayjs().startOf('month').format('YYYY-MM-DD'),
  );
  const [projectWiseToDate, setProjectWiseToDate] = useState(
    parsedStoredData?.projectWiseToDate || dayjs().endOf('month').format('YYYY-MM-DD'),
  );
  const [projectWiseSelectedTeam, setProjectWiseSelectedTeam] = useState(
    parsedStoredData?.projectWiseSelectedTeam || { id: -1, value: 'All' },
  );
    const [monthelyWiseSelectedTeam, setMonthelyWiseSelectedTeam] = useState(parsedStoredData?.monthelyWiseSelectedTeam || { id: -1, value: 'All' });
  const [monthelyWiseFromDate, setMonthelyWiseFromDate] = useState(parsedStoredData?.monthelyWiseFromDate || dayjs().startOf('month').format('YYYY-MM-DD'));
  const [monthelyWiseToDate, setMonthelyWiseToDate] = useState(parsedStoredData?.monthelyWiseToDate || dayjs().endOf('month').format('YYYY-MM-DD'));
 const [monthlyWiseSelectedProject,setMonthlyWiseSelectedProject] = useState(parsedStoredData?.monthlyWiseSelectedProject || { id: 0, value: 'All' });
 const[monthlyWiseSelectedCourse,setMonthlyWiseSelectedCourse] = useState(parsedStoredData?.monthlyWiseSelectedCourse || { id: -1, value: 'All' });
  const smDown = useResponsive('down', 'sm');
  const dispatch = useDispatch();
  const moduleTypes = [
    { id: 1, name: 'Team Performance Overview', shortName: 'TPO' },
    { id: 2, name: 'Team Perfomance', shortName: 'TPO' },
    { id: 3, name: 'Month Wise Analysis', shortName: 'MWA' },
  ];

  const clearAllReduxState = () => {
    // localStorage.removeItem('TeamWiseAnalyticsLanding');
    dispatch(clearTeamPerfomanceOverview()); //CLEAR REDUX STATE ON UNMOUNT
    dispatch(clearDailyTeamRevenue()); //CLEAR REDUX STATE ON UNMOUNT
    dispatch(clearDailyAssessmentCount()); //CLEAR REDUX STATE ON UNMOUNT
    dispatch(clearTeamWiseAnalysis()); //CLEAR REDUX STATE ON UNMOUNT
    dispatch(clearProjectWise()); //CLEAR REDUX STATE ON UNMOUNT
    dispatch(clearOgdOverview()); //CLEAR REDUX STATE ON UNMOUNT
    dispatch(clearTeamUserPerfomance()); //CLEAR REDUX STATE ON UNMOUNT
    dispatch(clearChaserCrewPerfomance()); //CLEAR REDUX STATE ON UNMOUNT
  };



  const setFiltersInLocalStorageSectionWise = () => {
    const objectSturcture = {
      selectedModuleType,
      teamPerfomanceParentDate,
      teamWiseAnalysisDate,
      projectWiseFromDate,
      projectWiseToDate,
      projectWiseSelectedTeam,
      monthelyWiseSelectedTeam,
      monthelyWiseFromDate,
      monthelyWiseToDate,
      monthlyWiseSelectedProject,
      monthlyWiseSelectedCourse,
    };
    localStorage.setItem('TeamWiseAnalyticsLanding', JSON.stringify(objectSturcture));
  };

  useEffect(() => {
    setFiltersInLocalStorageSectionWise();
  }, [
    selectedModuleType,
    teamPerfomanceParentDate,
    teamWiseAnalysisDate,
    projectWiseFromDate,
    projectWiseToDate,
    projectWiseSelectedTeam,
    monthelyWiseSelectedTeam,
    monthelyWiseFromDate,
    monthelyWiseToDate,
    monthlyWiseSelectedProject,
    monthlyWiseSelectedCourse,
  ]);
  return (
    <GlobalWrapper title="Team Wise Analytics" skelton={false}>
      <Box>
        <Button
          sx={{ marginLeft: '1px', px: 1, boxShadow: 'none', textTransform: 'none', mb: 0.8 }}
          onClick={clearAllReduxState}
          size="small"
          variant="contained"
          startIcon={<Icon icon="line-md:downloading-loop" width="24" height="24" />}
        >
          Refresh Data
        </Button>
      </Box>
      <TopSelectBar
        selectedModuleType={selectedModuleType}
        setSelectedModuleType={setSelectedModuleType}
        moduleTypes={moduleTypes}
        smDown={smDown}
      />
      <Box mt={2}>
        <AnimatePresence mode="popLayout">
          {selectedModuleType == 1 ? (
            <motion.div
              key={selectedModuleType}
              variants={animations.slideFromTop}
              initial="initial"
              animate="animate"
              exit="exit"
            >
              <Box display={'flex'} flexDirection={'column'} gap={3}>
                <Box width={'33%'}>
                  <DatePickerCustom
                    label={'Month'}
                    value={dayjs(teamPerfomanceParentDate)}
                    setValue={(date) => setTeamPerfomanceParentDate(date.format('YYYY-MM-DD'))}
                    viewDetails={['year', 'month']}
                    fullWidth
                    disabled={false}
                    height={36}
                    fontSize={'0.75rem'}
                  />
                </Box>
                <TeamPerfomanceOverview parentDate={teamPerfomanceParentDate} />
                <DailyTeamRevenue parentDate={teamPerfomanceParentDate} />
                <DailyAssessmentCount parentDate={teamPerfomanceParentDate} />
              </Box>
            </motion.div>
          ) : selectedModuleType == 2 ? (
            <motion.div
              key={selectedModuleType}
              variants={animations.slideFromRight}
              initial="initial"
              animate="animate"
              exit="exit"
            >
              <Box display={'flex'} flexDirection={'column'} gap={3}>
                <TeamWiseAnalysis
                  teamWiseAnalysisDate={teamWiseAnalysisDate}
                  setTeamWiseAnalysisDate={setTeamWiseAnalysisDate}
                />
                <ProjectWise
                  fromDate={projectWiseFromDate}
                  toDate={projectWiseToDate}
                  setFromDate={setProjectWiseFromDate}
                  setToDate={setProjectWiseToDate}
                  selectedTeam={projectWiseSelectedTeam}
                  setSelectedTeam={setProjectWiseSelectedTeam}
                />
              </Box>
            </motion.div>
          ) : selectedModuleType == 3 ? (
            <motion.div
              key={selectedModuleType}
              variants={animations.slideFromLeft}
              initial="initial"
              animate="animate"
              exit="exit"
            >
              <Box display={'flex'} flexDirection={'column'} gap={2}>
                <OGDOverview fromDate={monthelyWiseFromDate} toDate={monthelyWiseToDate} selectedTeam={monthelyWiseSelectedTeam} />
                <MonthlyWiseGlobalFilter fromDate={monthelyWiseFromDate} setFromDate={setMonthelyWiseFromDate} toDate={monthelyWiseToDate} setToDate={setMonthelyWiseToDate} setSelectedTeam={setMonthelyWiseSelectedTeam} selectedTeam={monthelyWiseSelectedTeam} />
                <TeamUserPerfomance fromDate={monthelyWiseFromDate} toDate={monthelyWiseToDate} selectedTeam={monthelyWiseSelectedTeam} />
                <ChaserCrewPerfomance fromDate={monthelyWiseFromDate} toDate={monthelyWiseToDate} selectedTeam={monthelyWiseSelectedTeam} selectedProject={monthlyWiseSelectedProject} selectedCourse={monthlyWiseSelectedCourse} setSelectedProject={setMonthlyWiseSelectedProject} setSelectedCourse={setMonthlyWiseSelectedCourse} />
                <DetailedPerfomanceMetrics fromDate={monthelyWiseFromDate} toDate={monthelyWiseToDate} selectedTeam={monthelyWiseSelectedTeam}  />
              </Box>
            </motion.div>
          ) : null}
        </AnimatePresence>
      </Box>
    </GlobalWrapper>
  );
};

export default TeamWiseAnalyticsLanding;
